export const getGiftCardPhrase = (
  baseText: string,
  cardPhrase: string,
): string => baseText.replace('$giftCardPhrase$', cardPhrase);
